import * as request from '@/utils/request'

/**
 * 列表
 * @param data
 * @returns {Promise}
 */
export function aiParseIngredientSearchList(data) {
  return request.post('/ai_parse_ingredient/list', data)
}

/**
 * 删除
 * @param id
 * @returns {Promise}
 */
export function aiParseIngredientDeleteRow(id) {
  return request.post('/ai_parse_ingredient/delete', { id: id })
}

/**
 * 同步AI解析成分
 * @returns {Promise}
 */
export function aiParseIngredientRunSyncScript() {
  return request.post('/ai_parse_ingredient/sync_ai_parse_ingredient', {})
}
